/* Customs Designer — front-end logic */
(function () {
  'use strict';

  function money(cents, format) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return (format || '${{amount}}').replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, v);
  }
  function parsePairs(str) {
    return (str || '').split(',').map(function (s) {
      var p = s.split('|');
      return { name: (p[0] || '').trim(), hex: (p[1] || '#cccccc').trim() };
    }).filter(function (c) { return c.name; });
  }
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }

  function Designer(root) {
    this.root = root;
    this.cfg = JSON.parse(root.querySelector('[data-cdz-config]').textContent);
    this.cfg.inks = parsePairs(this.cfg.inks);
    this.state = {
      blankIdx: 0, colorIdx: 0, sideIdx: 0, tab: 'blank',
      layers: [], selId: null, uid: 1,
      fontIdx: 0, ink: (this.cfg.inks[0] || { hex: '#111' }).hex, text: ''
    };
    this.productCache = {};
    this.q = {};
    [
      'stage', 'blankimg', 'area', 'layers', 'sides', 'hint', 'name', 'sub', 'price', 'price2',
      'breakdown', 'blanks', 'colors', 'library', 'inks', 'fonts', 'presets', 'textinput',
      'addtext', 'scale', 'rot', 'scaleout', 'rotout', 'center', 'remove', 'placeui',
      'placeempty', 'addtocart', 'pricenote', 'step', 'error', 'file'
    ].forEach(function (k) { this.q[k] = root.querySelector('[data-cdz-' + k + ']'); }, this);
    this.init();
  }

  Designer.prototype.blank = function () { return this.cfg.blanks[this.state.blankIdx] || null; };
  Designer.prototype.side = function () {
    var b = this.blank();
    return b && b.sides.length ? (b.sides[this.state.sideIdx] || b.sides[0]) : null;
  };
  Designer.prototype.slot = function () {
    var b = this.blank(), s = this.side();
    return b && s ? b.id + '|' + s.id : '';
  };
  Designer.prototype.usedSlots = function () {
    var b = this.blank(); if (!b) return [];
    var out = [];
    this.state.layers.forEach(function (l) {
      if (l.slot.indexOf(b.id + '|') === 0 && out.indexOf(l.slot) === -1) out.push(l.slot);
    });
    return out;
  };
  Designer.prototype.billable = function () {
    var n = this.usedSlots().length;
    return this.cfg.firstIncluded ? Math.max(0, n - 1) : n;
  };
  Designer.prototype.total = function () {
    var b = this.blank(); if (!b) return 0;
    return Number(b.price) + this.billable() * Number(this.cfg.fee);
  };
  Designer.prototype.fmt = function (units) { return money(units * 100, this.cfg.moneyFormat); };

  Designer.prototype.init = function () {
    var self = this;
    this.root.querySelectorAll('[data-cdz-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.state.tab = btn.getAttribute('data-cdz-tab');
        self.render();
      });
    });
    this.q.stage.addEventListener('pointerdown', function (e) {
      if (e.target === self.q.stage || e.target === self.q.blankimg || e.target === self.q.area) {
        self.state.selId = null; self.render();
      }
    });
    if (this.q.textinput) {
      this.q.textinput.addEventListener('input', function () {
        self.state.text = this.value.slice(0, self.cfg.textCharLimit);
      });
    }
    if (this.q.addtext) this.q.addtext.addEventListener('click', function () { self.addText(); });
    if (this.q.scale) this.q.scale.addEventListener('input', function () { self.patch({ scale: this.value / 100 }); });
    if (this.q.rot) this.q.rot.addEventListener('input', function () { self.patch({ rot: Number(this.value) }); });
    if (this.q.center) this.q.center.addEventListener('click', function () {
      var a = self.side().area; self.patch({ x: a.x, y: a.y });
    });
    if (this.q.remove) this.q.remove.addEventListener('click', function () {
      self.state.layers = self.state.layers.filter(function (l) { return l.id !== self.state.selId; });
      self.state.selId = null; self.render();
    });
    if (this.q.file) this.q.file.addEventListener('change', function () { self.handleUpload(this.files[0]); });
    if (this.q.addtocart) this.q.addtocart.addEventListener('click', function () { self.addToCart(); });
    this.buildStaticLists();
    this.render();
  };

  Designer.prototype.buildStaticLists = function () {
    var self = this;
    this.q.blanks.innerHTML = '';
    this.cfg.blanks.forEach(function (b, i) {
      var btn = el('button', 'cdz__card');
      btn.type = 'button';
      var thumb = el('span', 'cdz__cardthumb');
      if (b.sides[0] && b.sides[0].img) {
        var img = new Image(); img.src = b.sides[0].img; img.alt = ''; thumb.appendChild(img);
      }
      btn.appendChild(thumb);
      btn.appendChild(el('span', 'cdz__cardname', b.name));
      btn.appendChild(el('span', 'cdz__cardprice', 'from ' + self.fmt(b.price)));
      btn.addEventListener('click', function () {
        self.state.blankIdx = i; self.state.colorIdx = 0; self.state.sideIdx = 0; self.state.selId = null;
        self.render();
      });
      self.q.blanks.appendChild(btn);
      b._btn = btn;
    });

    this.q.library.innerHTML = '';
    this.cfg.art.forEach(function (a) {
      var btn = el('button', 'cdz__card');
      btn.type = 'button';
      var thumb = el('span', 'cdz__cardthumb');
      if (a.url) { var img = new Image(); img.src = a.url; img.alt = a.name; thumb.appendChild(img); }
      btn.appendChild(thumb);
      btn.appendChild(el('span', 'cdz__cardname', a.name));
      btn.addEventListener('click', function () {
        self.addLayer({ type: 'art', name: a.name, url: a.url });
      });
      self.q.library.appendChild(btn);
    });

    if (this.q.fonts) {
      this.q.fonts.innerHTML = '';
      this.cfg.fonts.forEach(function (f, i) {
        var btn = el('button', 'cdz__chip', f.name);
        btn.type = 'button';
        btn.style.fontFamily = f.family;
        if (f.italic) btn.style.fontStyle = 'italic';
        btn.addEventListener('click', function () { self.state.fontIdx = i; self.render(); });
        self.q.fonts.appendChild(btn);
        f._btn = btn;
      });
      if (!this.cfg.fonts.length) this.q.fonts.appendChild(el('span', 'cdz__note', 'Add a Text font block in the theme editor.'));
    }

    if (this.q.inks) {
      this.q.inks.innerHTML = '';
      this.cfg.inks.forEach(function (c) {
        var btn = el('button', 'cdz__swatch');
        btn.type = 'button';
        btn.title = c.name;
        btn.appendChild(el('span')).style.background = c.hex;
        btn.addEventListener('click', function () { self.state.ink = c.hex; self.render(); });
        self.q.inks.appendChild(btn);
        c._btn = btn;
      });
    }
  };

  Designer.prototype.presetsFor = function (side) {
    var a = side.area;
    return [
      { label: 'Left chest', x: a.x - a.w * 0.28, y: a.y - a.h * 0.28, scale: 0.42 },
      { label: 'Centred', x: a.x, y: a.y, scale: 0.8 },
      { label: 'Full area', x: a.x, y: a.y, scale: 1.25 }
    ];
  };

  Designer.prototype.addLayer = function (data) {
    var side = this.side(); if (!side) return;
    var a = side.area, id = 'L' + this.state.uid++;
    this.state.layers.push(Object.assign({ id: id, slot: this.slot(), x: a.x, y: a.y, scale: 0.8, rot: 0 }, data));
    this.state.selId = id;
    this.state.tab = 'place';
    this.render();
  };
  Designer.prototype.addText = function () {
    var t = (this.state.text || '').trim();
    if (!t) { this.flash('Type your text first.'); return; }
    var f = this.cfg.fonts[this.state.fontIdx] || { family: this.cfg.displayFont, italic: true, name: 'Default' };
    this.addLayer({ type: 'text', name: t, text: t, color: this.state.ink, family: f.family, italic: f.italic, fontName: f.name });
  };
  Designer.prototype.patch = function (p) {
    var self = this;
    this.state.layers = this.state.layers.map(function (l) {
      return l.id === self.state.selId ? Object.assign({}, l, p) : l;
    });
    this.render();
  };
  Designer.prototype.clamp = function (x, y) {
    var a = this.side().area, hw = a.w / 2, hh = a.h / 2;
    return {
      x: Math.min(a.x + hw, Math.max(a.x - hw, x)),
      y: Math.min(a.y + hh, Math.max(a.y - hh, y))
    };
  };

  Designer.prototype.handleUpload = function (file) {
    var self = this;
    if (!file) return;
    if (file.size > this.cfg.maxUploadMb * 1024 * 1024) {
      this.flash('That file is larger than ' + this.cfg.maxUploadMb + 'MB.');
      return;
    }
    var localUrl = URL.createObjectURL(file);
    this.addLayer({ type: 'art', name: file.name, url: localUrl, upload: true, uploading: !!this.cfg.uploadEndpoint });
    var layerId = this.state.selId;
    if (!this.cfg.uploadEndpoint) {
      this.flash('Preview only \u2014 no upload endpoint is configured, so this file will not reach the order.');
      return;
    }
    var fd = new FormData();
    fd.append('file', file);
    fetch(this.cfg.uploadEndpoint, { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var url = json.url || json.secure_url || json.location;
        if (!url) throw new Error('No URL returned');
        self.state.layers = self.state.layers.map(function (l) {
          return l.id === layerId ? Object.assign({}, l, { remoteUrl: url, uploading: false }) : l;
        });
        self.render();
      })
      .catch(function () {
        self.flash('Upload failed. Please try again or email the file to us.');
        self.state.layers = self.state.layers.filter(function (l) { return l.id !== layerId; });
        self.render();
      });
  };

  Designer.prototype.flash = function (msg) {
    var box = this.q.error;
    if (!box) return;
    box.textContent = msg;
    box.hidden = false;
    clearTimeout(this._flashT);
    this._flashT = setTimeout(function () { box.hidden = true; }, 5000);
  };

  Designer.prototype.startDrag = function (e, layer) {
    var self = this;
    e.stopPropagation();
    e.preventDefault();
    var box = this.q.stage.getBoundingClientRect();
    var ox = layer.x - ((e.clientX - box.left) / box.width) * 100;
    var oy = layer.y - ((e.clientY - box.top) / box.height) * 100;
    this.state.selId = layer.id;
    this.state.tab = 'place';
    this.render();
    function move(ev) {
      var c = self.clamp(
        ((ev.clientX - box.left) / box.width) * 100 + ox,
        ((ev.clientY - box.top) / box.height) * 100 + oy
      );
      self.state.layers = self.state.layers.map(function (l) {
        return l.id === layer.id ? Object.assign({}, l, c) : l;
      });
      self.render();
    }
    function up() {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
    }
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
  };

  Designer.prototype.render = function () {
    var self = this, st = this.state, b = this.blank(), side = this.side();

    this.root.querySelectorAll('[data-cdz-tab]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-cdz-tab') === st.tab);
    });
    this.root.querySelectorAll('[data-cdz-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-cdz-panel') !== st.tab;
    });
    if (this.q.step) {
      this.q.step.textContent = st.tab === 'blank' ? 'Step 1 of 3' : (st.tab === 'place' ? 'Step 3 of 3' : 'Step 2 of 3');
    }

    if (!b || !side) {
      this.q.hint.textContent = 'Add a Blank product block with a flat photo in the theme editor.';
      this.q.hint.hidden = false;
      return;
    }

    this.cfg.blanks.forEach(function (x, i) { if (x._btn) x._btn.classList.toggle('is-active', i === st.blankIdx); });
    this.cfg.fonts.forEach(function (f, i) { if (f._btn) f._btn.classList.toggle('is-active', i === st.fontIdx); });
    this.cfg.inks.forEach(function (c) { if (c._btn) c._btn.classList.toggle('is-active', c.hex === st.ink); });

    var color = b.colors[st.colorIdx] || { name: '', hex: '#ccc' };
    this.q.colors.innerHTML = '';
    b.colors.forEach(function (c, i) {
      var btn = el('button', 'cdz__swatch' + (i === st.colorIdx ? ' is-active' : ''));
      btn.type = 'button';
      btn.title = c.name;
      btn.appendChild(el('span')).style.background = c.hex;
      btn.addEventListener('click', function () { st.colorIdx = i; self.render(); });
      self.q.colors.appendChild(btn);
    });

    this.q.blankimg.src = side.img || '';
    this.q.blankimg.alt = b.name + ' \u2014 ' + side.label;

    var a = side.area;
    this.q.area.style.left = a.x + '%';
    this.q.area.style.top = a.y + '%';
    this.q.area.style.width = a.w + '%';
    this.q.area.style.height = a.h + '%';

    this.q.sides.innerHTML = '';
    b.sides.forEach(function (s, i) {
      var btn = el('button', 'cdz__side' + (i === st.sideIdx ? ' is-active' : ''), s.label);
      btn.type = 'button';
      btn.addEventListener('click', function () { st.sideIdx = i; st.selId = null; self.render(); });
      self.q.sides.appendChild(btn);
    });

    var slot = this.slot();
    this.q.layers.innerHTML = '';
    this.state.layers.filter(function (l) { return l.slot === slot; }).forEach(function (l) {
      var node = el('div', 'cdz__layer' + (l.id === st.selId ? ' is-selected' : ''));
      node.style.left = l.x + '%';
      node.style.top = l.y + '%';
      node.style.transform = 'translate(-50%,-50%) rotate(' + l.rot + 'deg) scale(' + l.scale + ')';
      node.style.width = a.w + '%';
      if (l.type === 'text') {
        var span = el('span', 'cdz__layertext', l.text);
        span.style.fontFamily = l.family;
        span.style.color = l.color;
        if (l.italic) span.style.fontStyle = 'italic';
        node.appendChild(span);
      } else {
        var img = new Image();
        img.src = l.url;
        img.alt = l.name;
        img.draggable = false;
        node.appendChild(img);
        if (l.uploading) node.appendChild(el('span', 'cdz__uploading', 'uploading\u2026'));
      }
      node.addEventListener('pointerdown', function (e) { self.startDrag(e, l); });
      self.q.layers.appendChild(node);
    });

    this.q.hint.hidden = this.state.layers.length > 0;

    var used = this.usedSlots(), billable = this.billable();
    this.q.name.textContent = b.name;
    this.q.sub.textContent = color.name + ' \u00b7 ' + (used.length ? used.length + ' print area' + (used.length > 1 ? 's' : '') : 'no artwork yet');
    var totalLabel = this.fmt(this.total());
    this.q.price.textContent = totalLabel;
    if (this.q.price2) this.q.price2.textContent = totalLabel;
    if (this.q.breakdown) {
      this.q.breakdown.textContent = this.fmt(b.price) + ' base' + (billable ? ' + ' + billable + ' \u00d7 ' + this.fmt(this.cfg.fee) : '');
    }
    if (this.q.pricenote) {
      this.q.pricenote.textContent = 'Print areas on this blank: ' +
        b.sides.map(function (s) { return s.label.toLowerCase(); }).join(', ') + '. ' +
        (this.cfg.firstIncluded
          ? 'First area is included in the ' + this.fmt(b.price) + ' base price, each extra area is ' + this.fmt(this.cfg.fee) + '.'
          : 'Base price is ' + this.fmt(b.price) + ' and every print area adds ' + this.fmt(this.cfg.fee) + '.');
    }

    var sel = this.state.layers.filter(function (l) { return l.id === st.selId && l.slot === slot; })[0];
    if (this.q.placeui) {
      this.q.placeui.hidden = !sel;
      this.q.placeempty.hidden = !!sel;
    }
    if (sel) {
      this.q.scale.value = Math.round(sel.scale * 100);
      this.q.rot.value = sel.rot;
      this.q.scaleout.textContent = Math.round(sel.scale * 100) + '%';
      this.q.rotout.textContent = sel.rot + '\u00b0';
      this.q.presets.innerHTML = '';
      this.presetsFor(side).forEach(function (p) {
        var active = Math.abs(sel.x - p.x) < 0.6 && Math.abs(sel.y - p.y) < 0.6 && Math.abs(sel.scale - p.scale) < 0.02;
        var btn = el('button', 'cdz__chip' + (active ? ' is-active' : ''), p.label);
        btn.type = 'button';
        btn.addEventListener('click', function () {
          var c = self.clamp(p.x, p.y);
          self.patch({ x: c.x, y: c.y, scale: p.scale });
        });
        self.q.presets.appendChild(btn);
      });
    }

    this.q.addtocart.disabled = used.length === 0;
  };

  Designer.prototype.resolveVariant = function () {
    var b = this.blank(), color = b.colors[this.state.colorIdx];
    if (!b.handle) return Promise.resolve(b.defaultVariant);
    var self = this;
    var get = this.productCache[b.handle]
      ? Promise.resolve(this.productCache[b.handle])
      : fetch(window.Shopify.routes.root + 'products/' + b.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { self.productCache[b.handle] = p; return p; });
    return get.then(function (p) {
      if (!color || !b.colorOption) return b.defaultVariant;
      var idx = p.options.map(function (o) {
        return (typeof o === 'string' ? o : o.name).toLowerCase();
      }).indexOf(b.colorOption.toLowerCase());
      if (idx === -1) return b.defaultVariant;
      var match = p.variants.filter(function (v) {
        return v.available && (v.options[idx] || '').toLowerCase() === color.name.toLowerCase();
      })[0];
      return match ? match.id : b.defaultVariant;
    }).catch(function () { return b.defaultVariant; });
  };

  Designer.prototype.properties = function () {
    var b = this.blank(), color = b.colors[this.state.colorIdx], props = {};
    props['Colour'] = color ? color.name : '';
    var self = this;
    b.sides.forEach(function (s) {
      var slot = b.id + '|' + s.id;
      var layers = self.state.layers.filter(function (l) { return l.slot === slot; });
      if (!layers.length) return;
      props[s.label + ' artwork'] = layers.map(function (l) {
        return l.type === 'text' ? '\u201c' + l.text + '\u201d (' + (l.fontName || 'text') + ', ' + l.color + ')' : l.name;
      }).join(' + ');
      props[s.label + ' placement'] = layers.map(function (l) {
        return 'x ' + l.x.toFixed(1) + '% / y ' + l.y.toFixed(1) + '% / size ' + Math.round(l.scale * 100) + '% / rotate ' + l.rot + '\u00b0';
      }).join(' | ');
      layers.forEach(function (l, i) {
        var url = l.remoteUrl || (l.upload ? null : l.url);
        if (url) props[s.label + ' file ' + (i + 1)] = url;
      });
    });
    return props;
  };

  Designer.prototype.addToCart = function () {
    var self = this, btn = this.q.addtocart, original = btn.textContent;
    var pending = this.state.layers.some(function (l) { return l.uploading; });
    if (pending) { this.flash('Your upload is still finishing \u2014 one moment.'); return; }
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    this.resolveVariant().then(function (variantId) {
      if (!variantId) throw new Error('This blank has no Shopify product selected yet.');
      var items = [{ id: variantId, quantity: 1, properties: self.properties() }];
      var billable = self.billable();
      if (billable > 0 && self.cfg.feeVariant) {
        items.push({
          id: self.cfg.feeVariant,
          quantity: billable,
          properties: { 'For': self.blank().name + ' \u2014 extra print areas' }
        });
      }
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Cart error'); });
        return r.json();
      });
    }).then(function () {
      window.location.href = window.Shopify.routes.root + 'cart';
    }).catch(function (err) {
      self.flash(err.message || 'Could not add to cart.');
      btn.disabled = false;
      btn.textContent = original;
    });
  };

  function boot() {
    document.querySelectorAll('[data-customs-designer]').forEach(function (root) {
      if (root.dataset.cdzReady) return;
      root.dataset.cdzReady = '1';
      try { new Designer(root); } catch (e) { console.error('[customs-designer]', e); }
    });
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  boot();
})();
